import { MessageDrawIcon } from './MessageDrawIcon';

/**
 * author: Google
 * id 6434A4B3-F803-4C8B-A03C-BE39E947166B
 * name message-draw
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-draw.svg
 * tags
 */
export const RateReviewIcon = MessageDrawIcon;
export default RateReviewIcon